import React, { useState, useEffect } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { Button, Spinner, Col, Row, Form, FormGroup, Label, Input, Alert,
    Nav, NavItem, NavLink, TabContent, TabPane, CustomInput, ListGroup, ListGroupItem, ListGroupItemHeading, Badge,
    Modal, ModalHeader, ModalBody, ModalFooter, FormFeedback, FormText, InputGroup, InputGroupAddon, InputGroupText, Table, Progress } from 'reactstrap';
//country list
// @ts-ignore
import countryList from 'react-select-country-list'
import { Prompt, NavLink as RouterNavLink } from 'react-router-dom';
// @ts-ignore
import Select from 'react-select';
import { FaCheckCircle } from "react-icons/fa";
// @ts-ignore
import TimeField from 'react-simple-timefield';
import moment from 'moment';
import BlobUtil from '../../utils/blobUtil';
// @ts-ignore
import DatePicker from 'reactstrap-date-picker';
// @ts-ignore
import randomstring from "randomstring";
import VideoPlayer from './VideoPlayer';
import CreatableSelect from 'react-select/creatable';
import ReactDOM from 'react-dom';
// @ts-ignore
import { EditorState, ContentState, RichUtils, convertToRaw, convertFromHTML } from 'draft-js';
// @ts-ignore
import { Editor } from 'react-draft-wysiwyg';
import '../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
// @ts-ignore
import { convertToHTML } from 'draft-convert';

export default function DetailForm({props, read, save, remove, 
    overwriteWarningFlag, overwriteHandleWarning, isNew, newCourseId, uploadProgress}: any) {
  
  const editor = React.useRef(null);
  const [editorState, setEditorState] = React.useState(
    EditorState.createWithContent(
        ContentState.createFromBlockArray(
          convertFromHTML(props.data?.longDesc? props.data?.longDesc: "<p></p>")
        )
      )
  );

  const [overwriteFlag, setOverwriteFlag] = useState("false");
  const [removeWarning, setRemoveWarning] = useState(false);
  const toggleRemoveWarning = () => setRemoveWarning(!removeWarning);

  const [eTag, setETag] = useState(""); // Detect changes on data
  const [isSaved, setIsSaved] = useState(false);

  const _professionalCategory = [
    { value: 'Accountancy', label: 'Accountancy' },
    { value: 'Company Secretary', label: 'Company Secretary' },
    { value: 'Tax Agent', label: 'Tax Agent' },
    { value: 'Contractor', label: 'Contractor' },
    { value: 'Engineering', label: 'Engineering' },
    { value: 'Project Management', label: 'Project Management' },
    { value: 'Arts & Culture', label: 'Arts & Culture' },
    { value: 'MBOT', label: 'MBOT' }
  ];

  const _languageCategory = [
    { value: 'English', label: 'English' },
    { value: 'Chinese', label: 'Chinese' },
    { value: 'Malay', label: 'Malay' },
  ];

  countryList().setLabel('TW', 'Taiwan')
  countryList().setLabel('AX', 'All')
  const _countryOptions = countryList().getData();

  const { register, handleSubmit, reset, watch, errors, formState, control  } = useForm();

  // Read the formState before render to subscribe the form state through Proxy
  const { dirty, isSubmitting, isSubmitted, touched, submitCount } = formState;

  
  const [ CQFlag, setCQFlag] = useState(false);
  const toggleCQFlag = () => {
    resetState();
    setCQFlag(!CQFlag);
  }

  const [ UploadFlag, setUploadFlag] = useState(false);
  const toggleUploadFlag = () => {
    setUploadFlag(!UploadFlag);
  }

  const [ NewCQ, setNewCQ] = useState('');

  const [ _currencyType, setCurrencyType ] = useState((props.data?.currency) ? props.data?.currency : "MYR");

  const [ selectedCPD, setCPDCourse ] = useState("");
  const [ cpdArray, setCPDArray ] = useState((props.data?.cpdPoints) ? props.data?.cpdPoints : []);
  const [ _POInputDuration, setPOInputDuration ] = useState('');
  const [ _POInputProgram, setPOInputProgram ] = useState('');
  const [ _programOutline, setProgramOutline ] = useState((props.data?.programOutline) ? props.data?.programOutline : []);
  const [ _CFInput, setCFValue ] = useState('');
  const [ _courseFeatures, setCourseFeatures ] = useState((props.data?.courseFeatures) ? props.data?.courseFeatures : []);
  const [ _concentrateQuestion, setconcentrateQuestion ] = useState((props.data?.concentrationDurationSettingsJSON) ? props.data?.concentrationDurationSettingsJSON : []);
  const [ _picTime, setPicTime ] = useState({
      picTime1: "00:00:00",
      picTime2: "00:00:00",
      picTime3: "00:00:00",
      picTime4: "00:00:00",
      picTime5: "00:00:00",
  });
  const [ _ansTime, setAnsTime ] = useState("00:00:00");
  const [ _publishDT, setPublishDT ] = useState(props.data?.publishedDT);
  const [ _expiryDT, setExpiryDT ] = useState(props.data?.expiryDT);
  const [ _courseShelfLifeDays, setCourseShelfLifeDays ] = useState(props.data?.courseShelfLifeDays);
  const [ _courseStatus, setCourseStatus ] = useState((props.data?.courseStatus) ? props.data?.courseStatus : "Active");
  const [ _courseDuration, setCourseDuration ] = useState(props.data?.duration);

  const [ _inputFile, setInputFile ] = useState();
  const [ _trainerFAQ, setTrainerFAQ ] = useState(props.data?.trainerFAQFileURL);
  const [ _trainerFlag, setTrainerFlag] = useState(true);
  const [ _courseSliders, setCourseSliders ] = useState(props.data?.slidesFileURL);
  const [ _slideFlag, setSlideFlag] = useState(true);

  const [ _courseImge, setCourseImage ] = useState(props.data?.videoThumbnailURL);
  const [ _courseImageFlag, setCourseImageFlag] = useState(true);

  const [ _courseFlyer, setCourseFlyer ] = useState(props.data?.courseFlyerURL);
  const [ _courseFlyerFlag, setCourseFlyerFlag] = useState(true);

  const [ _courseCPDPointInfo, setCourseCPDPointInfo ] = useState(props.data?.courseCPDPointURL);
  const [ _courseCPDPointInfoFlag, setCourseCPDPointInfoFlag] = useState(true);

  const [ _courseVideo, setCourseVideo ] = useState(props.data?.videoURL);
  const [ _courseVideoFlag, setCourseVideoFlag] = useState(true);
  const [ _sourceVideo, setSourceVideo ] = useState({
    src: _courseVideo,
    type: "video/mp4"
  });
  const [ _uploadProgress, setUploadProgress ] = useState(uploadProgress);

  const [ _selectedOrganiser, setSelectedOrganiser ] = useState((props.data?.organiser) ? props.data?.organiser : {});
  const [ _selectedTrainer, setSelectedTrainer ] = useState(props.data?.trainerProfile);

  const [publishFlag, setPublishFlag] = useState("true");

  const organiserCategory: any = [];
  const _trainerProfile: any = [];
  const trainerProfiles: any = [];
  
  const discountCodeOptionsList: any = [];
  props.data?.discountCode?.map((s:string)=>{
    discountCodeOptionsList.push({value:s, label:s});
  })

  props.dataOrganiser?.map(function (elem: any) {
    organiserCategory.push({ value: elem.orgName, label: elem.orgName });
    _trainerProfile.push({
        orgName: elem.orgName,
        trainerCategory: (elem.trainers) ? constructSelectSelection(elem.trainers) : []
    });
  });

  props.dataOrganiser?.filter(function (elem: any) {
      elem.trainers?.forEach((element: any) => {
          trainerProfiles.push(element);
      });
  });

  const [ _trainerCategory, setTrainerCategory ] = useState(() => {
    const index :number = _trainerProfile?.map(function(p: any) { return p.orgName; }).indexOf(props.data?.organiser.orgName);
    if (index !== -1) {
        return (_trainerProfile[index].trainerCategory);
    }
  });

  const concentrationCategory: any = [];
  props.dataConcentration?.map(function (elem: any) {
    concentrationCategory.push({ value: elem.id, label: elem.name });
  });

  const onSubmit = (data : any, e: any) => {
    if (data.publishStatus === "false") {
        if (window.confirm("Are you sure want to unpublish this course?")) {
            let expiryDT = new Date();    
            let newDT = moment(expiryDT).subtract(1, 'days');
            setExpiryDT(newDT.toISOString());
            setCourseStatus('UnPublished');
            data.expiryDT = newDT.toISOString();
            data.courseStatus = 'UnPublished';
        }
    }
    else if (data.publishStatus === "true") {
        let publishDT = new Date(_publishDT);    
        let newDT = moment(publishDT).add(Number(_courseShelfLifeDays), 'days');
        setExpiryDT(newDT.toISOString());
        setCourseStatus('Active');
        data.expiryDT = newDT.toISOString();
        data.courseStatus = 'Active';
    }

    data.longDesc = convertToHTML(editorState.getCurrentContent());
    //console.log(convertToHTML(editorState.getCurrentContent()));
    //console.log(editorState.getCurrentContent());
    //console.log(convertToRaw(editorState.getCurrentContent()));

    //console.log(data)
    save(data);
    setIsSaved(true);
  };

  const watchFields = watch(["_etag"]);
  if (watchFields){
      if (watchFields._etag !== undefined && props.data?._etag !== undefined && (eTag === "" || eTag != props.data?._etag)){
        setETag(props.data._etag);
        //console.log("_etag updated..." + props.data._etag);
        if (isSaved){ // Reset only if record updated and issubmitted
            //console.log("Call Reset");
            setTimeout(() => {
                reset();
                setIsSaved(false);
            }, 0)
            
        }
      }
  }

  const handleRequestDelete = () => {
    remove(props.data);
    setRemoveWarning(!removeWarning);
  }
  
  const handleReloadData = () => {
    read();
    overwriteHandleWarning();
  }

  function constructSelectSelection(trainer: any) {
    let trainerCategory: any = [];

    trainer.forEach(function (element: any) {
        trainerCategory.push({ value: element.name, label: element.name });
    });

    return trainerCategory;
  }

  const addCPDCourse = (e: any) => {
    const index :number = cpdArray?.map(function(p: any) { return p.profession; }).indexOf(e);
    if (index < 0) { 
        let newObj: any = {
            profession: e,
            points: 0,
            cpdRefNo: "",
            cpdDesc : "",
            cpdIssuerName : "",
            cpdVerification : true,
            cpdExpiry : ""
        }
        setCPDArray([...cpdArray, newObj]);
    }
    setCPDCourse("");
  }
  
  const removeCPDCourse = (e: any) => {
    if (window.confirm("Are you sure want to remove this CPD?")) {
        const index :number = cpdArray?.map(function(p: any) { return p.profession; }).indexOf(e);
        if (index !== -1) {
            setCPDArray((_cpdArray: any) => _cpdArray.filter((_cpd: any) => _cpd.profession !== e));
        }
    }
  }

  const handleCPDCourse = (e: any) => {
    if (e) {
        e.forEach((element: any) => {
            if (element.action === undefined) {
                setCPDCourse(element.value);
            }
        });
    }
  }

  const handleCPDCoursePoint = (e: any) => {
    if (e) {
        let matchObj = cpdArray.filter(function (item: any) {
            return e.target.name.toLowerCase().startsWith(item.profession.toLowerCase());
        });
        if (matchObj) {
            matchObj[0].points = Number(e.target.value);
        }
    }
  }

  const handleCPDCourseRefNo = (e: any) => {
    if (e) {
        let matchObj = cpdArray.filter(function (item: any) {
            return e.target.name.toLowerCase().startsWith(item.profession.toLowerCase());
        });
        if (matchObj) {
            matchObj[0].cpdRefNo = e.target.value;
        }
    }
  }
  
  const handleCPDDesc = (e: any) => {
    if (e) {
        let matchObj = cpdArray.filter(function (item: any) {
            return e.target.name.toLowerCase().startsWith(item.profession.toLowerCase());
        });
        if (matchObj) {
            matchObj[0].cpdDesc = e.target.value;
        }
    }
  }
  
  const handleCPDIssuer = (e: any) => {
    if (e) {
        let matchObj = cpdArray.filter(function (item: any) {
            return e.target.name.toLowerCase().startsWith(item.profession.toLowerCase());
        });
        if (matchObj) {
            matchObj[0].cpdIssuerName = e.target.value;
        }
    }
  }
  const handleCPDVerification = (e: any) => {
    if (e) {
        let matchObj = cpdArray.filter(function (item: any) {
            return e.target.name.toLowerCase().startsWith(item.profession.toLowerCase());
        });
        if (matchObj) {
            matchObj[0].cpdVerification = !matchObj[0].cpdVerification;
        }
    }
  }

  const handleCPDExpiryDate = (e: any) => {
    if (e) {
        let matchObj = cpdArray.filter(function (item: any) {
            return e.target.name.toLowerCase().startsWith(item.profession.toLowerCase());
        });
        if (matchObj) {
            matchObj[0].cpdExpiry = e.target.value;
        }
    }
  }
//   const handleCPDExpiryDate = (v: any, f: any) => {
//     if (v) {
//         console.log(v);
//         console.log(f);
        
//         // let matchObj = cpdArray.filter(function (item: any) {
//         //     return e.target.name.toLowerCase().startsWith(item.profession.toLowerCase());
//         // });
//         // if (matchObj) {
//         //     matchObj[0].cpdExpiry = e.target.value;
//         // }
//     }
//   }
  const handleCPDExpiryDateBlur = (e: any) => {
    if (e) {
        console.log('Blur');
        console.log(e);
    }
  }
  const handleMultiSelectedOption = (optionList: any, name: any) => {
    let arr: any = [];
    if (name && optionList){
        name.forEach((element:any) => {
            let index = optionList.map(function(e: any) { 
                return e.label; 
            }).indexOf(element);
    
            if (index !== -1) {
                arr.push(optionList[index]);
            }
            //for react-select with creatable
            // else {
            //     optionList.push({value: element, label: element});
            //     let index1 = optionList.map(function(e: any) { 
            //         return e.label; 
            //     }).indexOf(element);
            //     arr.push(optionList[index1]);
            // }
        });
    }

    return arr;
  }

  const handleMultiCountrySelectedOption = (optionList: any, name: any) => {
    let arr: any = [];
    if (name && optionList){
        // console.log(name);
        // console.log(optionList);
        name.forEach((element:any) => {
            let index = optionList.map(function(e: any) { 
                //return e.label; 
                return e.value;  // Country Code instead of Country Name
            }).indexOf(element);
            if (index !== -1) {
                arr.push(optionList[index]);
            }
        });
    }

    return arr;
  }

  const handleMultiSelectedOption2 = (optionList: any, name: any) => {
    if (name){
        name.forEach((element:any) => {
            let index = optionList.map(function(e: any) { 
                return e.value; 
            }).indexOf(element);
    
            if (index >= 0) {
                optionList.splice(index, 1);
            }
        });
    }

    return optionList;
  }

  const handleSelectedOption3 = (optionList: any, name: any, objKey: string) => {
    let arr: any = [];
    if (name){
        let index = optionList.map(function(e: any) { 
            return e.value; 
        }).indexOf(name[objKey]);

        if (index !== -1) {
            arr.push(optionList[index]);
        }
    }

    return arr;
  }

  const handleSelectedOption4 = (optionList: any, id: any) => {
    let arr: any = [];
    if (id){
        let index = optionList.map(function(e: any) { 
            return e.value; 
        }).indexOf(id);

        if (index !== -1) {
            arr.push(optionList[index]);
        }
    }

    return arr;
  }
  
  // Course Features
  const handleCFInput = (e: any) => {
    setCFValue(e.target.value);
  }

  const addCF = (e: any) => {
    let newArr: any = [];

    if (e === '')
        return ;

    if (_courseFeatures)
        newArr = _courseFeatures.slice();

    const index :number = newArr.indexOf(e);
    if (index < 0) { 
        setCourseFeatures([..._courseFeatures, e]);
    }
    
    setCFValue('');
  }

  const removeCF = (e: any) => {
    if (window.confirm("Are you sure want to remove this course feature?")) {
        const index :number = _courseFeatures.indexOf(e);
        if (index !== -1) {
            setCourseFeatures((_courseFeatures: any) => _courseFeatures.filter((_po: any) => _po !== e));
        }
    }
  }

  const handleCurrencyType = (e: any) => {
    //console.log(e.target.value)
    setCurrencyType(e.target.value);
    return e.target.value;
  }

  // Program Outline
  const handlePOInputDuration = (e: any) => {
    setPOInputDuration(e.target.value);
  }
  const handlePOInputProgram = (e: any) => {
    setPOInputProgram(e.target.value);
  }

  const addPO = (duration: any, program:any) => {
    let newArr: any = [];

    if (duration === '' || program === '')
        return ;

    if (_programOutline)
        newArr = _programOutline.slice();

    // const index :number = newArr.indexOf(e);
    // if (index < 0) { 
    //     setProgramOutline([..._programOutline, e]);
    // }

    setProgramOutline([..._programOutline, {"duration":duration, "program": program}]);
    
    setPOInputDuration('');
    setPOInputProgram('');
  }

  const removePO = (e: any) => {
    if (window.confirm("Are you sure want to remove this program outline?")) {
        const index :number = _programOutline.indexOf(e);
        if (index !== -1) {
            setProgramOutline((_programOutline: any) => _programOutline.filter((_po: any) => _po !== e));
        }
    }
  }

  const addConcentrateQuestion = (e: any) => {
    let _picTimeFlag = true;
    let _ansTimeFlag = true;
    let picTimeValues = Object.values(_picTime);
    let picTimeCounter = 0;
    let ansTimeValue = Object.values(_concentrateQuestion.map(function (item: any) {return item.AnswerSpot; }));

    picTimeValues.forEach((element: any, index: number) => {
        if (element === "00:00:00") {
            picTimeCounter++;
        }

        if (moment.duration(element).asSeconds() >= moment.duration(_ansTime).asSeconds()) {
            _ansTimeFlag = false;
        }
    });
    picTimeValues = picTimeValues.filter((e: any) => { return (e !== "00:00:00"); });

    if (picTimeCounter > 3) {
        _picTimeFlag = false
        alert("Required at least 2 popup picture time.");
        return ;
    }

    if (!_ansTimeFlag) {
        alert("Answer time must be after the popup time.");
        return ;
    }

    // if (ansTimeValue.indexOf(Number(moment.duration(_ansTime).asSeconds())) !== -1 ) {
    //     alert("Answer time existed!");
    //     return ;
    // }

    if (_picTimeFlag && _ansTimeFlag) {
        let newCQArr = [..._concentrateQuestion];
        if (NewCQ === '') {
            let newObj = {
                id: _concentrateQuestion.length + 1,
                duration: picTimeValues.map(function(item: any) { return Number(moment.duration(item).asSeconds()); }),
                AnswerSpot: Number(moment.duration(_ansTime).asSeconds())
            }
            newCQArr.push(newObj);
        }
        else {
            let existingCQ =  _concentrateQuestion?.filter(function(p: any) { return p.id === NewCQ; });
            let updateObj = {
                id: existingCQ[0].id,
                duration: picTimeValues.map(function(item: any) { return Number(moment.duration(item).asSeconds()); }),
                AnswerSpot: Number(moment.duration(_ansTime).asSeconds())
            }
            newCQArr[existingCQ[0].id - 1] = updateObj;
        }
        newCQArr = RearrangeSequences(newCQArr);
        newCQArr.forEach((obj: any, index: number) => {
            obj.id = index + 1;
        });

        let matchObj = newCQArr.filter(function (item: any) {
            return item.AnswerSpot === Number(moment.duration(_ansTime).asSeconds());
        });

        if (matchObj.length > 0) {
            let id = matchObj[0].id;
            let prevObj = newCQArr.filter(function (item: any) {
                return item.id === (id - 1);
            });

            let matchObjPopupTimeValues: any = Object.values(matchObj[0].duration);
            if (prevObj.length > 0 && matchObjPopupTimeValues[0] <= prevObj[0].AnswerSpot) {
                // setconcentrateQuestion((_concentrateQuestion: any) => _concentrateQuestion.filter((_cq: any) => _cq.id !== id));
                alert("Popup picture time is not greater than previous record answer picture time");
                return ;
            }
        }

        setconcentrateQuestion(newCQArr);
        toggleCQFlag();
    }
  }

  function RearrangeSequences(CQArray: any) {
    return CQArray.sort((a: any, b: any) => (a.AnswerSpot > b.AnswerSpot) ? 1 : -1);
  }

  const resetState = () => {
    setNewCQ('');
    setPicTime({
        picTime1: "00:00:00",
        picTime2: "00:00:00",
        picTime3: "00:00:00",
        picTime4: "00:00:00",
        picTime5: "00:00:00",
    });
    setAnsTime("00:00:00");
  }

  const handleSetPicTime = (e: any) => {
    // console.log(e);
    const { name, value } = e.target;
    setPicTime({ ..._picTime, [name]: value});
  }

  const handleSetAnsTime = (e: any) => {
    setAnsTime(e.target.value);
  }
  
  const handleEditCQ = (e: any, elem: any) => {
    let newArr =  _concentrateQuestion?.filter(function(p: any) { return p.id === elem; });

    setCQFlag(!CQFlag);
    setNewCQ(elem);
    if (newArr.length > 0) {
        let picTimeArr: any = Object.values(newArr[0]["duration"]);
        let newPicTimeObj: any = {
            picTime1: (picTimeArr[0]) ? new Date(picTimeArr[0] * 1000).toISOString().substr(11, 8) : "00:00:00",
            picTime2: (picTimeArr[1]) ? new Date(picTimeArr[1] * 1000).toISOString().substr(11, 8) : "00:00:00",
            picTime3: (picTimeArr[2]) ? new Date(picTimeArr[2] * 1000).toISOString().substr(11, 8) : "00:00:00",
            picTime4: (picTimeArr[3]) ? new Date(picTimeArr[3] * 1000).toISOString().substr(11, 8) : "00:00:00",
            picTime5: (picTimeArr[4]) ? new Date(picTimeArr[4] * 1000).toISOString().substr(11, 8) : "00:00:00",
        }
        setPicTime(newPicTimeObj);
        setAnsTime(new Date(newArr[0].AnswerSpot * 1000).toISOString().substr(11, 8));
    }
  }

  const handleRemoveCQ = (f: any, elem: any) => {
    const index :number = _concentrateQuestion?.map(function(p: any) { return p.id; }).indexOf(elem);
    if (index !== -1) {
        setconcentrateQuestion((_concentrateQuestion: any) => _concentrateQuestion.filter((_cq: any) => _cq.id !== elem));
    }
  }

  const handleCourseDuration = (event: any) => {
    setCourseDuration(Number(moment.duration(event.target.value).asSeconds()).toString());
  }

  function timeConverter(duration: any) {
      let secArr: any = [];

      duration?.forEach((element: any) => {
        secArr.push(toHHMMSS(element));
      });

      return secArr;
  }

  function toHHMMSS(seconds: any) {
    var h, m, s, result='';
    // HOURs
    h = Math.floor(seconds/3600);
    seconds -= h*3600;
    if(h){
        result = h<10 ? '0'+h+':' : h+':';
    }
    // MINUTEs
    m = Math.floor(seconds/60);
    seconds -= m*60;
    result += m<10 ? '0'+m+':' : m+':';
    // SECONDs
    s=seconds%60;
    result += s<10 ? '0'+s : s;
    return result;
  }

  const handlePublishDT = (e: any) => {
    let publishDT = new Date(e[0]);
    let newDT = moment(publishDT).add(Number(_courseShelfLifeDays), 'days');
    setPublishDT(e[0]);
    setExpiryDT(newDT.toISOString());
    return e[0];
  }

  const handleCourseShelfLifeDays = (e: any) => {
    setCourseShelfLifeDays(e.target.value);
    let publishDT = new Date(_publishDT);    
    let newDT = moment(publishDT).add(Number(e.target.value), 'days');
    setExpiryDT(newDT.toISOString());
  }

  const handleCourseImg = (event: any) => {
    event.preventDefault();
    
    if (event.target.files.length > 0) {
        let randomString = randomstring.generate({
            length: 10,
            charset: 'alphanumeric',
            capitalization: 'uppercase'
        });
        let filename = "courses/" + randomString + ".jpg";
        setCourseImage(filename);
        setCourseImageFlag(!_courseImageFlag);
        setInputFile(event.target.files);
    }
  }

  const handleCourseFlyer = (event: any) => {
    event.preventDefault();
    
    if (event.target.files.length > 0) {
        let randomString = randomstring.generate({
            length: 10,
            charset: 'alphanumeric',
            capitalization: 'uppercase'
        });
        let filename = "courses/" + randomString + ".jpg";
        setCourseFlyer(filename);
        setCourseFlyerFlag(!_courseFlyerFlag);
        setInputFile(event.target.files);
    }
  }
  const handleCourseCPDPointInfo = (event: any) => {
    event.preventDefault();
    
    if (event.target.files.length > 0) {
        let randomString = randomstring.generate({
            length: 10,
            charset: 'alphanumeric',
            capitalization: 'uppercase'
        });
        let filename = "courses/" + randomString + ".jpg";
        setCourseCPDPointInfo(filename);
        setCourseCPDPointInfoFlag(!_courseFlyerFlag);
        setInputFile(event.target.files);
    }
  }

  const handleTrainerFAQ = (event: any) => {
    event.preventDefault();

    if (event.target.files.length > 0) {
        let filename = props.data?.id + "/trainer.pdf";
        setTrainerFAQ(filename);
        setTrainerFlag(!_trainerFlag);
        setInputFile(event.target.files);
    }
  }
  

  const handleCourseSliders = (event: any) => {
    event.preventDefault();

    if (event.target.files.length > 0) {
        let filename = props.data?.id + "/slide.pdf";
        setCourseSliders(filename);
        setSlideFlag(!_slideFlag);
        setInputFile(event.target.files);
    }
  }

  const handleCourseVideo = (event: any) => {
    event.preventDefault();

    if (event.target.files.length > 0) {
        let randomString = randomstring.generate({
            length: 10,
            charset: 'alphanumeric',
            capitalization: 'uppercase'
        });
        let filename = props.data?.id + "/" + randomString + ".mp4";
        setCourseVideo(filename);
        setCourseVideoFlag(!_courseVideoFlag);
        setInputFile(event.target.files);
    }
  }

  async function handlePreview(event: any) {
    let fileName = '';

    if (event.target.name === "trainer") fileName = _trainerFAQ;
    if (event.target.name === "slides") fileName = _courseSliders;

    let blobRequestUrl = await new BlobUtil().GetBlob2("courses", fileName);
    window.open(blobRequestUrl, "_blank");
  }

  const handleSelectedOrganiser = (e: any) => {
    if (e) {
        e.forEach((element: any) => {
            if (element && element.action === undefined) {
                const index :number = organiserCategory?.map(function(p: any) { return p.value; }).indexOf(element.value);
                if (index !== -1) {
                    let matchedOrganiser = props.dataOrganiser?.filter(function (item: any) { return item.orgName === element.value; });
                    let _organiserObj: any = {
                        id: matchedOrganiser[0].id,
                        oId: matchedOrganiser[0].oId,
                        orgName: matchedOrganiser[0].orgName,
                        orgProfile: matchedOrganiser[0].orgProfile,
                        orgProfileImgURL: matchedOrganiser[0].orgProfileImgURL,
                        orgEmail: matchedOrganiser[0].orgEmail,
                        orgPhoneNo: matchedOrganiser[0].orgPhoneNo,
                        orgAddress: matchedOrganiser[0].orgAddress,
                        orgProfession: matchedOrganiser[0].orgProfession,
                        contactPersonName: matchedOrganiser[0].contactPersonName,
                        contactPersonTitle: matchedOrganiser[0].contactPersonTitle,
                        contactPersonPhone: matchedOrganiser[0].contactPersonPhone,
                        contactPersonWorkPhone: matchedOrganiser[0].contactPersonWorkPhone,
                        contactPersonEmail: matchedOrganiser[0].contactPersonEmail,  
                        // trainers : matchedOrganiser[0].trainers,
                        // searchKeywords : matchedOrganiser[0].searchKeywords
                    }
                    setSelectedOrganiser(_organiserObj);
                    setSelectedTrainer(null);

                    const index2 :number = _trainerProfile?.map(function(p: any) { return p.orgName; }).indexOf(element.value);
                    if (index2 !== -1) {
                        setTrainerCategory(_trainerProfile[index2].trainerCategory);
                    }
                }
            }
        });
    }
  }

  const handleSelectedTrainer = (e: any) => {
    let newArr: any = [];
    if (e) {
        e.forEach((element: any) => {
            // if (element && element.action === undefined) {
                // element.forEach((item: any) => {
                    const index :number = trainerProfiles?.map(function(p: any) { return p.name; }).indexOf(element.value);
                    if (index !== -1) {
                        let matchedTrainer = trainerProfiles[index];
                        let _trainerObj: any = {
                            id: matchedTrainer.id,
                            name: matchedTrainer.name,
                            profile: matchedTrainer.profile,
                            profileImgURL: matchedTrainer.profileImgURL,
                            profession: matchedTrainer.profession
                        }
                        newArr.push(_trainerObj);
                    }
                // });
            // }
        });
    }
    setSelectedTrainer(newArr);
  }

  async function handleUploadAction(event: any) {
    event.preventDefault();

    let fileName = '';
    let target = event.target.name;
    let fileUploadProgressInterval: any;
    let blobUtil = new BlobUtil();

    setUploadProgress(0);

    if (target === "trainer") fileName = _trainerFAQ;
    if (target === "slides") fileName = _courseSliders;
    if (target === "video") fileName = _courseVideo;
    if (target === "image") fileName = _courseImge;
    if (target === "flyer") fileName = _courseFlyer;
    if (target === "cpdPointInfo") fileName = _courseCPDPointInfo;

    if (_inputFile) {
        setUploadFlag(false);
        toggleUploadFlag();
        fileUploadProgressInterval = setInterval(async () => {
            setUploadProgress(blobUtil.getUploadProgress());
        }, 500);
        if (target === "image" || target === "flyer" || target === "cpdPointInfo") {
            let blobRequestUrl = await blobUtil.UploadBlobToCointainer3(fileName, _inputFile?.[0], "images");
        }
        else {
            let blobRequestUrl = await blobUtil.UploadBlobToCointainer3(fileName, _inputFile?.[0], "courses");    
        }    
        clearInterval(fileUploadProgressInterval);
        setUploadProgress(100);
        
        if (target === "trainer") setTrainerFlag(!_trainerFlag);
        if (target === "slides") setSlideFlag(!_slideFlag);
        if (target === "image") {
            let newObj: any = {
                src: (_courseVideo) ? _courseVideo : "",
                type: "video/mp4"
            }
            setSourceVideo(newObj);
            setCourseImageFlag(!_courseImageFlag);
        }
        if (target === "flyer") {
            setCourseFlyerFlag(!_courseFlyerFlag);
        }
        if (target === "cpdPointInfo") {
            setCourseCPDPointInfoFlag(!_courseCPDPointInfoFlag);
        }
        if (target === "video") {
            let newObj: any = {
                src: fileName,
                type: "video/mp4"
            }
            setSourceVideo(newObj);
            setCourseVideoFlag(!_courseVideoFlag);
        }
    }    
    else {
        alert("Please select file first before upload.");
        return ;
    }
  }
  
  // console.log(errors);
  // {errors}

  //console.log("===> Render details form")
  function focusEditor() {
    //this.editor.current.focus();
  }
 
  React.useEffect(() => {
    focusEditor()
  }, []);

  function handleKeyCommand(command:any, editorState:any) {
    const newState = RichUtils.handleKeyCommand(editorState, command);

    if (newState) {
      setEditorState(newState);
      //this.onChange(newState);
      return 'handled';
    }

    return 'not-handled';
  }
  return (
      <div className="container">
        <Form id='DetailsFrom' onSubmit={handleSubmit(onSubmit)}>
            <ListGroup>
                <ListGroupItem>
                    <ListGroupItemHeading>Course Information</ListGroupItemHeading>
                    <ListGroupItem>
                        <FormGroup row={true}>
                            <Label for="courseId" lg={3} sm={2}>Course Id</Label >
                            <Col lg={9} sm={10}>
                                <Input type="text" name="courseId" readOnly={!isNew} defaultValue={props.data?.courseId?? newCourseId} 
                                    innerRef={register({ required: true, minLength:6, maxLength : 6 })} />
                                {errors.courseId && <FormText color="danger">Required field. Course id must be 5 characters.</FormText>}
                            </Col>
                        </FormGroup>
                        <FormGroup row={true}>
                            <Label for="title" lg={3} sm={2}>Title</Label >
                            <Col lg={9} sm={10}>
                                <Input type="text" name="title" defaultValue={props.data?.title} 
                                    innerRef={register({ required: true, minLength:10 })} />
                                {errors.title && <FormText color="danger">Required field. Minimum length 10 character.</FormText>}
                            </Col>
                        </FormGroup>
                        <FormGroup row={true}>
                            <Label for="referenceNumber" lg={3} sm={2}>Reference Number</Label >
                            <Col lg={9} sm={10}>
                                <Input type="text" name="referenceNumber" placeholder="Certificate reference number" 
                                    defaultValue={props.data?.referenceNumber} 
                                    innerRef={register} />

                                {errors.referenceNumber && <FormText color="danger">Required field.</FormText>}
                            </Col>
                        </FormGroup>
                        <FormGroup row={true}>
                            <Label for="professionList" lg={3} sm={2}>Professional Category</Label >
                            <Col lg={9} sm={10}>
                                <Controller 
                                    as={Select}
                                    name="professionList"
                                    options={_professionalCategory}
                                    isMulti
                                    control={control}
                                    defaultValue={handleMultiSelectedOption(_professionalCategory, props.data?.professionList)}
                                />
                                {errors.professionList && <FormText color="danger">Required field.</FormText>}
                            </Col>
                        </FormGroup>
                        <FormGroup row={true}>
                            <Label for="countryList" lg={3} sm={2}>Country / Region</Label >
                            <Col lg={9} sm={10}>
                                <Controller
                                    as={Select}
                                    name="countryList"
                                    options={_countryOptions}
                                    isMulti
                                    control={control}
                                    defaultValue={handleMultiCountrySelectedOption(_countryOptions, props.data?.countryList)}
                                />
                                {errors.countryList && <FormText color="danger">Required field.</FormText>}
                            </Col>
                        </FormGroup>
                        <FormGroup row={true}>
                            <Label for="languages" lg={3} sm={2}>Languages</Label >
                            <Col lg={9} sm={10}>
                                <Controller
                                    as={Select}
                                    name="languages"
                                    options={_languageCategory}
                                    isMulti
                                    control={control}
                                    defaultValue={handleMultiSelectedOption(_languageCategory, props.data?.languages)}
                                />
                                {errors.languages && <FormText color="danger">Required field.</FormText>}
                            </Col>
                        </FormGroup>
                        <FormGroup row={true}>
                            <Label for="subtitle" lg={3} sm={2}>Subtitle</Label >
                            <Col lg={9} sm={10}>
                                <Controller
                                    as={Select}
                                    name="subtitle"
                                    options={_languageCategory}
                                    isMulti
                                    control={control}
                                    defaultValue={handleMultiSelectedOption(_languageCategory, props.data?.subtitle)}
                                />
                                {errors.subtitle && <FormText color="danger">Required field.</FormText>}
                            </Col>
                        </FormGroup>
                        <FormGroup row={true}>
                            <Label for="organiser" lg={3} sm={2}>Organiser</Label >
                            <Col lg={9} sm={10}>
                                <Controller 
                                    as={Select}
                                    classNamePrefix="custom-select"
                                    name="organiserSelection"
                                    options={organiserCategory}
                                    defaultValue={handleSelectedOption3(organiserCategory, _selectedOrganiser, "orgName")}
                                    onChange={handleSelectedOrganiser}
                                    control={control}
                                />
                            </Col>
                        </FormGroup>

                        {/* Trainer selection shall put inside Controller component, but if put inside Controller component then value unable
                            to clear after select another option in organiser selection. But if didnt put inside Controller component, value
                            able to clear but save button in form will not be trigger.
                        */}
                        <FormGroup row={true}>
                            <Label for="trainerProfile" lg={3} sm={2}>Trainer</Label >
                            <Col lg={9} sm={10}>
                                {/* <Controller 
                                    as={Select}
                                    classNamePrefix="custom-select"
                                    name="trainerSelection"
                                    options={_trainerCategory}
                                    isMulti
                                    defaultValue={handleMultiSelectedOption(_trainerCategory, _selectedTrainer?.map((item: any) => { return item.name; }))}
                                    onChange={handleSelectedTrainer}
                                    control={control}
                                /> */}
                                <Select 
                                    classNamePrefix="custom-select"
                                    name="trainerSelection"
                                    options={_trainerCategory}
                                    isMulti
                                    value={handleMultiSelectedOption(_trainerCategory, _selectedTrainer?.map((item: any) => { return item.name; }))}
                                    // value={_selectedTrainer}
                                    onChange={handleSelectedTrainer}
                                />
                            </Col>
                        </FormGroup>
                        {
                            !isNew && (
                                <FormGroup row={true}>
                                    <Label for="courseStatus" lg={3} sm={2}>Course Status</Label >
                                    <Col lg={9} sm={10}>
                                        {
                                            (_courseStatus === "Active") && (
                                                <h3 className="mb-0"><Badge color="success" pill>&nbsp;{_courseStatus}&nbsp;</Badge></h3>
                                            ) ||
                                            (_courseStatus === "UnPublished") && (
                                                <h3 className="mb-0"><Badge color="warning" pill>&nbsp;{_courseStatus}&nbsp;</Badge></h3>
                                            )
                                        }                                        
                                    </Col>
                                </FormGroup>
                            )
                        }
                        <FormGroup row={true}>
                            <Label for="Verification" lg={3} sm={2}>Verification Options</Label >
                            <Col lg={2} sm={2}>
                                <Label>
                                    <Input type="checkbox" style={{top: "7px"}} name="verification" defaultChecked={props.data?.verification}
                                    innerRef={register({ })} />{' '}
                                    <img width='36px' src='data:image/svg+xml;base64,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' />
                                    Verification
                                </Label>
                                {errors.verification && <FormText color="danger">Required field.</FormText>}
                            </Col>
                            <Col lg={2} sm={2}>
                                <Label>
                                    <Input type="checkbox" style={{top: "7px"}}  name="noVerification" defaultChecked={props.data?.noVerification}
                                    innerRef={register({ })} />{' '}
                                    <img width='36px' src='data:image/svg+xml;base64,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' />
                                    No Verification
                                </Label>
                                {errors.noVerification && <FormText color="danger">Required field.</FormText>}
                            </Col>
                            <Col lg={4} sm={4}>
                                <Label>
                                    <Input type="checkbox" style={{top: "5px"}}  name="noTracking" defaultChecked={props.data?.noTracking}
                                    innerRef={register({ })} />{' '}
                                    <img width='36px' src='data:image/svg+xml;base64,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' />
                                    No Tracking (For No Verification Only)
                                </Label>
                            </Col>
                        </FormGroup>
                        <FormGroup row={true}>
                            <Col lg={4} sm={4}>
                                <p>
                                    <h5>Verification</h5>
                                    <ul>
                                        <li>Face Recognition</li>
                                        <li>Concentration (Optional)</li>
                                        <li>Must follow track</li>
                                    </ul>
                                </p>
                            </Col>
                            <Col lg={4} sm={4}>
                                <p>
                                    <h5>No Verification</h5>
                                    <ul>
                                        <li>No Face Recognition</li>
                                        <li>Concentration (Optional)</li>
                                        <li>Must follow track</li>
                                    </ul>
                                </p>
                            </Col>
                            <Col lg={4} sm={4}>
                                <p>
                                    <h5>No Tracking</h5><ul>
                                        <li>No Face Recognition</li>
                                        <li>No Concentration</li>
                                        <li>No need to follow track</li>
                                    </ul>
                                </p>
                            </Col>
                        </FormGroup>
                    </ListGroupItem>
                </ListGroupItem>
            </ListGroup>
            <br />
            <ListGroup>
                <Row>
                    <Col lg={6}>
                        <ListGroupItem>
                            <ListGroupItemHeading>Pricing</ListGroupItemHeading>
                            <ListGroupItem>
                                <FormGroup row={true}>
                                    <Label for="currency" lg={4} sm={2}>Currency</Label >
                                    <Col lg={4} sm={4}>
                                        <Label check>
                                            <Input type="radio" name="currency" innerRef={register} value="MYR" onChange={handleCurrencyType} checked={_currencyType === "MYR"}/>{' '}MYR
                                        </Label>
                                    </Col>
                                    <Col lg={4} sm={4}>
                                        <Label check>
                                            <Input type="radio" name="currency" innerRef={register} value="USD" onChange={handleCurrencyType} checked={_currencyType === "USD"}/>{' '}USD
                                        </Label>
                                    </Col>
                                </FormGroup>
                                <FormGroup row={true}>
                                    <Label for="normalPrice" lg={4} sm={2}>Normal Price</Label >
                                    <Col lg={8} sm={10}>
                                        <InputGroup>
                                            <InputGroupAddon addonType="prepend">
                                                <InputGroupText>{_currencyType}</InputGroupText>
                                            </InputGroupAddon>
                                            <Input type="number" name="normalPrice" step="any" placeholder="Normal Price" 
                                                    defaultValue={props.data?.normalPrice} style={{textAlign:"right"}} 
                                                    innerRef={register} />
                                        </InputGroup>
                                        {errors.normalPrice && <FormText color="danger">Required field.</FormText>}
                                    </Col>
                                </FormGroup>
                                <FormGroup row={true}>
                                    <Label for="memberPrice" lg={4} sm={2}>Member Price</Label >
                                    <Col lg={8} sm={10}>
                                        <InputGroup>
                                            <InputGroupAddon addonType="prepend">
                                                <InputGroupText>{_currencyType}</InputGroupText>
                                            </InputGroupAddon>
                                            <Input type="number" name="memberPrice" step="any" placeholder="Member Price" 
                                                    defaultValue={props.data?.memberPrice} style={{textAlign:"right"}} 
                                                    innerRef={register} />
                                        </InputGroup>
                                        {errors.memberPrice && <FormText color="danger">Required field.</FormText>}
                                    </Col>
                                </FormGroup>
                                <FormGroup row={true}>
                                    <Label for="discountCode" lg={4} sm={2}>Discount Code</Label >
                                    <Col lg={8} sm={10}>
                                        <Controller
                                            as={<CreatableSelect />}
                                            control={control} 
                                            defaultValue={discountCodeOptionsList}
                                            name="discountCode"
                                            isMulti={true}
                                            isClearable={true}
                                        />
                                    </Col>
                                </FormGroup>
                                <FormGroup row={true}>
                                    <Label for="discountPrice" lg={4} sm={2}>Discount Price</Label >
                                    <Col lg={8} sm={10}>
                                        <InputGroup>
                                            <InputGroupAddon addonType="prepend">
                                                <InputGroupText>{_currencyType}</InputGroupText>
                                            </InputGroupAddon>
                                            {/* <Input type="number" onKeyDown={e => /[\+\-\.\,]$/.test(e.key) && e.preventDefault()} name="discountPrice" placeholder="Discount Price" 
                                                    defaultValue={props.data?.discountPrice} 
                                                    innerRef={register} /> */}
                                            <Input type="number" name="discountPrice" placeholder="Discount Price" 
                                                defaultValue={props.data?.discountPrice} style={{textAlign:"right"}} 
                                                innerRef={register} />
                                        </InputGroup>
                                        {errors.discountPrice && <FormText color="danger">Required field.</FormText>}
                                    </Col>
                                </FormGroup>
                                <FormGroup row={true}>
                                    <Label for="priceAdjNoVerification" lg={4} sm={2}>Price Adjustment No Verification</Label >
                                    <Col lg={8} sm={10}>
                                        <InputGroup>
                                            <InputGroupAddon addonType="prepend">
                                                <InputGroupText>{_currencyType}</InputGroupText>
                                            </InputGroupAddon>
                                            <Input type="number" name="priceAdjNoVerification" placeholder="+/- Price Adjustment" 
                                                defaultValue={props.data?.priceAdjNoVerification} style={{textAlign:"right"}} 
                                                innerRef={register} />
                                        </InputGroup>
                                        {errors.priceAdjNoVerification && <FormText color="danger">Required field.</FormText>}
                                    </Col>
                                </FormGroup>
                            </ListGroupItem>
                        </ListGroupItem>
                    </Col>
                    <Col lg={6}>
                        <ListGroupItem>
                            <ListGroupItemHeading>Publication</ListGroupItemHeading>
                            <ListGroupItem>
                                <FormGroup row={true}>
                                    <Label for="publishedDT" lg={5} sm={2}>Publish Date Time</Label >
                                    <Col lg={7} sm={10}>
                                        <Controller
                                            as={<DatePicker />}
                                            control={control}
                                            name="publishedDT"
                                            defaultValue={_publishDT}
                                            onChange={handlePublishDT}
                                            dateFormat={"DD/MM/YYYY"}
                                            minDate={new Date().toISOString()}
                                            showClearButton={false}
                                        />
                                    </Col>
                                </FormGroup>
                                <FormGroup row={true}>
                                    <Label for="courseShelfLifeDays" lg={5} sm={2}>Course Shelf Life Days</Label >
                                    <Col lg={7} sm={10}>
                                        <InputGroup>
                                            <Input type="number" name="courseShelfLifeDays" placeholder="Course Shelf Life Days" 
                                                    defaultValue={props.data?.courseShelfLifeDays} 
                                                    onChange={handleCourseShelfLifeDays} style={{textAlign:"right"}} 
                                                    onKeyDown={e => /[\+\-\.\,]$/.test(e.key) && e.preventDefault()}
                                                    innerRef={register} />
                                            <InputGroupAddon addonType="append">
                                                <InputGroupText>Days</InputGroupText>
                                            </InputGroupAddon>
                                        </InputGroup>
                                        {errors.courseShelfLifeDays && <FormText color="danger">Required field.</FormText>}
                                    </Col>
                                </FormGroup>
                                <FormGroup row={true}>
                                    <Label for="userShelfLifeDays" lg={5} sm={2}>User Shelf Life Days</Label >
                                    <Col lg={7} sm={10}>
                                        <InputGroup>
                                            <Input type="number" name="userShelfLifeDays" placeholder="User Shelf Life Days" 
                                                    defaultValue={props.data?.userShelfLifeDays}  style={{textAlign:"right"}}  
                                                    onKeyDown={e => /[\+\-\.\,]$/.test(e.key) && e.preventDefault()}
                                                    innerRef={register} />
                                            <InputGroupAddon addonType="append">
                                                <InputGroupText>Days</InputGroupText>
                                            </InputGroupAddon>
                                        </InputGroup>
                                        {errors.userShelfLifeDays && <FormText color="danger">Required field.</FormText>}
                                    </Col>
                                </FormGroup>
                                <FormGroup row={true}>
                                    <Label for="expiryDT" lg={5} sm={2}>Expired Date Time</Label >
                                    <Col lg={7} sm={10}>        
                                        <DatePicker
                                            value={_expiryDT}
                                            dateFormat={"DD/MM/YYYY"}
                                            showClearButton={false}
                                            disabled={true}
                                        />
                                    </Col>
                                </FormGroup>
                            </ListGroupItem>
                        </ListGroupItem>
                    </Col>
                </Row>
            </ListGroup>
            <br />
            <ListGroup>
                <ListGroupItem>
                    <ListGroupItemHeading>About this course</ListGroupItemHeading>
                    <ListGroupItem>
                        <FormGroup row={true}>
                            <Label for="shortDesc" lg={3} sm={2}>Short Description*</Label >
                            <Col lg={9} sm={10}>
                                <Input type="textarea" name="shortDesc" defaultValue={props.data?.shortDesc} rows={2} style={{width: "100%"}}
                                    innerRef={register({ required: true })} />
                                {errors.shortDesc && <FormText color="danger">Required field.</FormText>}
                            </Col>
                        </FormGroup>
                    <FormGroup row={true}>
                        <Label for="longDesc" lg={3} sm={2}>Long Description*</Label >
                        <Col lg={9} sm={10}>
                            {/* <Input type="textarea" name="longDesc" defaultValue={props.data?.longDesc} rows={5} style={{width: "100%"}}
                                innerRef={register({ required: true })} /> */}
                            {errors.longDesc && <FormText color="danger">Required field.</FormText>}
                            
                                <Editor
                                    toolbar={{
                                        options:['inline']
                                    }}
                                    ref={editor}
                                    editorState={editorState}
                                    wrapperClassName="demo-wrapper"
                                    editorClassName="demo-editor"
                                    onEditorStateChange={(editorState:any) => setEditorState(editorState)}
                                />
                            
                        </Col>
                        </FormGroup>
                    <FormGroup row={true}>
                        <Label for="objective" lg={3} sm={2}>Objective</Label >
                        <Col lg={9} sm={10}>
                            <Input type="textarea" name="objective" defaultValue={props.data?.objective} rows={5} style={{width: "100%"}}
                                innerRef={register({ required: true })} />
                            {errors.objective && <FormText color="danger">Required field.</FormText>}
                        </Col>
                    </FormGroup>
                    <FormGroup row={true}>
                        <Label for="methodology" lg={3} sm={2}>Methodology</Label >
                        <Col lg={9} sm={10}>
                            <Input type="textarea" name="methodology" defaultValue={props.data?.methodology} rows={5} style={{width: "100%"}}
                                innerRef={register({ })} />
                            {errors.methodology && <FormText color="danger">Required field.</FormText>}
                        </Col>
                    </FormGroup>
                    <FormGroup row={true}>
                        <Label for="qualification" lg={3} sm={2}>Qualification</Label >
                        <Col lg={9} sm={10}>
                            <Input type="textarea" name="qualification" defaultValue={props.data?.qualification} rows={5} style={{width: "100%"}}
                                innerRef={register({ })} />
                            {errors.qualification && <FormText color="danger">Required field.</FormText>}
                        </Col>
                    </FormGroup>
                    <FormGroup row={true}>
                        <Label for="requirement" lg={3} sm={2}>Requirement</Label >
                        <Col lg={9} sm={10}>
                            <Input type="textarea" name="requirement" defaultValue={props.data?.requirement} rows={5} style={{width: "100%"}}
                                innerRef={register({ })} />
                            {errors.requirement && <FormText color="danger">Required field.</FormText>}
                        </Col>
                    </FormGroup>
                    <FormGroup row={true}>
                        <Label for="termsAndConditions" lg={3} sm={2}>Terms & Condition</Label >
                        <Col lg={9} sm={10}>
                            <Input type="textarea" name="termsAndConditions" defaultValue={props.data?.termsAndConditions} rows={5} style={{width: "100%"}}
                                innerRef={register({ })} />
                            {errors.termsAndConditions && <FormText color="danger">Required field.</FormText>}
                        </Col>
                    </FormGroup>
                    <FormGroup row={true}>
                        <Label for="agenda" lg={3} sm={2}>Agenda</Label >
                        <Col lg={9} sm={10}>
                            <Input type="textarea" name="agenda" defaultValue={props.data?.agenda} rows={5} style={{width: "100%"}}
                                innerRef={register({ })} />
                            {errors.agenda && <FormText color="danger">Required field.</FormText>}
                        </Col>
                    </FormGroup>
                    </ListGroupItem>
                </ListGroupItem>
            </ListGroup>
            <br />
            <ListGroup>
                <ListGroupItem>
                    <ListGroupItemHeading>Program Outline</ListGroupItemHeading>
                    <ListGroupItem>
                        <FormGroup row={true}>
                            <Label for="po" lg={3} sm={2}>Program Outline</Label >
                            <Col lg={7} sm={8}>
                                <table>
                                    <tbody>
                                        <td style={{width:"20%", textAlign:"center"}}>
                                            <Input type="text" name="poDuration" onBlur={handlePOInputDuration} placeholder="Duration"
                                            innerRef={register} />{errors.programOutline && <FormText color="danger">Required field.</FormText>}
                                        </td>
                                        <td style={{width:"80%"}}>
                                            <Input type="text" name="poProgram" onBlur={handlePOInputProgram}  placeholder="Enter Program Module"
                                            innerRef={register} />
                                             {errors.programOutline && <FormText color="danger">Required field.</FormText>}
                                        </td>
                                    </tbody>
                                </table>
                            </Col>
                            <Button color="primary" onClick={() => addPO(_POInputDuration, _POInputProgram)}>Add New</Button>
                        </FormGroup>
                        <FormGroup row={true} style={{backgroundColor: "white", marginBottom: 0, lineHeight: "36px"}}>
                            <Label for="po" lg={3} sm={2}></Label >
                            <Col lg={7} sm={8}>
                                <table className="programOutlineTable">
                                    <thead style={{fontWeight:"bold"}}>
                                        <tr style={{backgroundColor:"lightgrey"}}>
                                            <td style={{textAlign:"center"}}>Duration</td>
                                            <td style={{textAlign:"center"}}>Module</td>
                                            <td style={{textAlign:"center"}}></td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {
                                        _programOutline?.map((e: any) => 
                                            // <FormGroup row={true} style={{backgroundColor: "lightgrey", marginBottom: 0, lineHeight: "36px"}}>
                                            //         <Col lg={3} sm={2} style={{backgroundColor: "white"}}></Col>
                                            //         <Col lg={8} sm={8}>
                                            //             <FaCheckCircle color="green" />&nbsp;{e}
                                            //         </Col>
                                            //         <Button close onClick={() => removePO(e)} title="Remove" />
                                            // </FormGroup>
                                            <tr>
                                                <td style={{width:"20%", textAlign:"center"}}>{e.duration}</td>
                                                <td style={{width:"80%"}}>{e.program}</td>
                                                <td><Button close onClick={() => removePO(e)} title="Remove" /></td>
                                            </tr>
                                        )
                                    }  
                                    </tbody>
                                </table>
                            </Col>
                        </FormGroup>
                    </ListGroupItem>
                </ListGroupItem>
            </ListGroup>
            <br />
            <ListGroup>
                <ListGroupItem>
                    <ListGroupItemHeading>Course Features</ListGroupItemHeading>
                    <ListGroupItem>
                        <FormGroup row={true}>
                            <Label for="cf" lg={3} sm={2}>Course Features</Label >
                            <Col lg={7} sm={8}>
                                <Input type="text" name="cf" onBlur={handleCFInput} 
                                        innerRef={register} />
                                    {errors.courseFeatures && <FormText color="danger">Required field.</FormText>}
                            </Col>
                            <Button color="primary" onClick={() => addCF(_CFInput)}>Add New</Button>
                        </FormGroup>
                        {
                            _courseFeatures?.map((e: any) => 
                                <FormGroup row={true} style={{backgroundColor: "lightgrey", marginBottom: 0, lineHeight: "36px"}}>
                                        <Col lg={3} sm={2} style={{backgroundColor: "white"}}></Col>
                                        <Col lg={8} sm={8}>
                                            <FaCheckCircle color="green" />&nbsp;{e}
                                        </Col>
                                        <Button close onClick={() => removeCF(e)} title="Remove" />
                                </FormGroup>
                            )
                        }
                    </ListGroupItem>
                </ListGroupItem>
            </ListGroup>
            <br />
            <ListGroup>
                <ListGroupItem>
                    <ListGroupItemHeading>Credit Hours/Points</ListGroupItemHeading>
                    <ListGroupItem>
                        {/* {JSON.stringify(cpdArray)} */}
                        <FormGroup row={true}>
                            <Label for="cpd" lg={3} sm={2}>Credit Hours/Points</Label >
                            <Col lg={7} sm={8}>
                                <Controller 
                                    as={Select}
                                    name="cpd"
                                    options={handleMultiSelectedOption2(_professionalCategory, cpdArray?.map((item: any) => { return item.profession; }))}
                                    control={control}
                                    onChange={handleCPDCourse}
                                />
                                {errors.cpdPoints && <FormText color="danger">Required field.</FormText>}
                            </Col>
                            <Button color="primary" onClick={() => addCPDCourse(selectedCPD)} disabled={ selectedCPD === "" ? true : false }>Add New</Button>
                        </FormGroup>
                        {
                            cpdArray?.map((e: any, index: number) => 
                                <FormGroup className="custom-div" style={{backgroundColor: "lightgrey"}}>
                                    <Label lg={11} sm={12} style={{fontWeight: 700}}>{e.profession}</Label>
                                    <Button close title="Remove" style={{padding: "3px 15px"}} onClick={() => removeCPDCourse(e.profession)}></Button>
                                    <Row style={{margin: "0px", marginBottom: "1em", paddingBottom: "1em"}}>
                                        <Label for={e.profession} lg={2} sm={2}>Description: </Label >
                                        <Col lg={10} sm={10}>
                                            <Input type="text" name={e.profession + '-'+ index} placeholder="Description in Public page and Certification" 
                                                    defaultValue={ e.cpdDesc } 
                                                    onChange={handleCPDDesc}
                                                    innerRef={register} />
                                        </Col>
                                        <Label for={e.profession} lg={2} sm={2}>Authority Name: </Label >
                                        <Col lg={10} sm={10}>
                                            <Input type="text" name={e.profession + '-'+ index} placeholder="Issuing Authority/Association" 
                                                    defaultValue={ e.cpdIssuerName } 
                                                    onChange={handleCPDIssuer}
                                                    innerRef={register} />
                                        </Col>
                                        <Label for={e.profession} lg={2} sm={2}>Verification: </Label >
                                        <Col lg={10} sm={10}>
                                             <Label>
                                                    <Input type="checkbox" name={e.profession + '-'+ index} defaultChecked={ e.cpdVerification }
                                                    onChange={handleCPDVerification}
                                                    innerRef={register({ })} 
                                                    style={{marginLeft: "10px", top: "8px"}}
                                                    />{' '}
                                                    <span style={{marginLeft: "28px"}}>Required Verification</span>
                                            </Label>
                                        </Col>
                                        <Label for={e.profession} lg={2} sm={2}>Expiry Date: </Label >
                                        <Col lg={3} sm={3}>
                                             <Label>
                                                <Input type="text" name={e.profession + '-'+ index} placeholder="Date in dd/mm/yyyy" 
                                                    defaultValue={ e.cpdExpiry } 
                                                    onChange={handleCPDExpiryDate}
                                                    innerRef={register} />
                                                {/* <DatePicker
                                                    name={e.profession}
                                                    className={e.profession + '-'+ index}
                                                    value={e.cpdExpiry}
                                                    onChange={(v:any, f:any) => handleCPDExpiryDate(v, f)}
                                                    onBlur={handleCPDExpiryDateBlur}
                                                    dateFormat={"DD/MM/YYYY"}
                                                    showClearButton={false}
                                                /> */}
                                            </Label>
                                        </Col>
                                        <Label for={e.profession} lg={1} sm={1}>Points: </Label >
                                        <Col lg={5} sm={5}>
                                            <Input type="number" name={e.profession + '-'+ index} placeholder="Credit Hours/Points" 
                                                    defaultValue={ e.points } 
                                                    onChange={handleCPDCoursePoint}
                                                    innerRef={register} />
                                        </Col>
                                        <Label for={e.profession} lg={2} sm={2}>Ref. No.: </Label >
                                        <Col lg={10} sm={10}>
                                            <Input type="textarea" name={e.profession + '-'+ index} placeholder="CPD Reference Number" 
                                                    rowNo={5}
                                                    defaultValue={ e.cpdRefNo } 
                                                    onChange={handleCPDCourseRefNo}
                                                    innerRef={register} />
                                        </Col>
                                    </Row>
                                </FormGroup>
                            )
                        }
                    </ListGroupItem>
                </ListGroupItem>
            </ListGroup>
            <br />
            <ListGroup>
                <ListGroupItem>
                    <Row style={{margin: "0 0 10px 0"}}>
                        <Col lg={10} className="pl-0">
                            <ListGroupItemHeading>Concentrate Question</ListGroupItemHeading>
                        </Col>
                        <Button color="primary" onClick={toggleCQFlag} >Add New</Button>
                    </Row>
                    <ListGroupItem>
                        <FormGroup className="mb-0" row={true} hidden={ (_concentrateQuestion?.length > 0) ? false : true }>
                            <Table className="mb-0">
                                <thead>
                                    <th>Popup Picture Time</th>
                                    <th>Answer Picture Time</th>
                                    <th></th>
                                </thead>
                                <tbody>
                                    {
                                        _concentrateQuestion?.map((e: any) => 
                                            <tr>
                                                <td>{ timeConverter(e.duration).join(", ") } </td>
                                                <td>{ toHHMMSS(e.AnswerSpot) }</td>
                                                <td>
                                                    <Button className="bg-warning text-dark" onClick={(f) => handleEditCQ(f, e.id)}>Edit</Button>
                                                    &nbsp;
                                                    <Button onClick={(f) => handleRemoveCQ(f, e.id)}>Remove</Button>
                                                </td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </Table>
                        </FormGroup>
                    </ListGroupItem>
                    <br />
                    <FormGroup row={true}>
                        <Label for="concentrationId" lg={3} sm={2}>Concentration Set</Label >
                        <Col lg={9} sm={10}>
                            <Controller 
                                as={Select}
                                classNamePrefix="custom-select"
                                name="concentrationId"
                                options={concentrationCategory}
                                control={control}
                                defaultValue={handleSelectedOption4(concentrationCategory, props.data?.concentrationId)}
                            />
                            {errors.professionList && <FormText color="danger">Required field.</FormText>}
                        </Col>
                    </FormGroup>
                </ListGroupItem>
            </ListGroup>
            <br />
            {
                !isNew && (
                    <ListGroup>
                        <ListGroupItem>
                            <ListGroupItemHeading>Course Materials (Please click on "Save" button once upload completed)</ListGroupItemHeading>
                            <ListGroupItem>
                                <FormGroup row={true}>
                                    <Label for="trainerFAQ" lg={3} sm={2}>Trainer FAQ</Label >
                                    <Col lg={7} sm={4} style={{display: "flex"}}>
                                        <CustomInput id="1" type="file" name="trainerFAQ" accept="application/pdf" 
                                            onChange={handleTrainerFAQ} 
                                            innerRef={register} />
                                    </Col>
                                    <Button color="primary" disabled={_trainerFlag} name="trainer" onClick={handleUploadAction}>Upload</Button>
                                    {/* <Button color="primary" disabled={(_trainerFAQ) ? false : true} name="trainer" onClick={handleUploadAction}>Upload</Button> */}
                                    <Button color="primary" style={{marginLeft: "5px"}} disabled={(_trainerFlag === true && _trainerFAQ) ? false : true} name="trainer" onClick={handlePreview}>Preview</Button>
                                </FormGroup>
                                <FormGroup row={true}>
                                    <Label for="courseSlides" lg={3} sm={2}>Course Sliders</Label >
                                    <Col lg={7} sm={4} style={{display: "flex"}}>
                                        <CustomInput id="2" type="file" name="courseSlides" accept="application/pdf" 
                                            onChange={handleCourseSliders} 
                                            innerRef={register} />
                                    </Col>
                                    <Button color="primary" disabled={_slideFlag} name="slides" onClick={handleUploadAction}>Upload</Button>
                                    {/* <Button color="primary" disabled={(_courseSliders) ? false : true} name="slides" onClick={handleUploadAction}>Upload</Button> */}
                                    <Button color="primary" style={{marginLeft: "5px"}} disabled={(_slideFlag === true && _courseSliders) ? false : true} name="slides" onClick={handlePreview}>Preview</Button>
                                </FormGroup>
                                <FormGroup row={true}>
                                    <Label for="duration" lg={3} sm={2}>Course Duration</Label >
                                    <Col lg={9} sm={10}>
                                        <Col lg={4} className="pl-0">
                                            <TimeField
                                                value={(_courseDuration) ? new Date(Number(_courseDuration) * 1000).toISOString().substr(11, 8) : "00:00:00"}
                                                name="courseDuration"
                                                onChange={handleCourseDuration}
                                                showSeconds
                                                style={{width: "70px"}}
                                            />
                                            {errors.duration && <FormText color="danger">Required field.</FormText>}
                                        </Col>
                                    </Col>
                                </FormGroup>
                                <FormGroup row={true}>
                                    <Label for="img" lg={3} sm={2}>Upload Course Image<br/><span style={{fontSize:"smaller"}}>(800px x 1280px)</span></Label >
                                    <Col lg={7} sm={4} style={{display: "flex"}}>
                                        <CustomInput id="3" type="file" name="img" accept="image/png, image/jpeg, image/jpg" 
                                            onChange={handleCourseImg} 
                                            innerRef={register} />
                                    </Col>
                                    <Button color="primary" disabled={_courseImageFlag} name="image" onClick={handleUploadAction}>Upload</Button>
                                    {
                                        _courseImageFlag === true && _courseImge && (
                                            <Col lg={12} sm={12} style={{paddingTop: "10px", textAlign: "center"}}>
                                                <img 
                                                    // ref={getProfilePicture}
                                                    src={"https://images.ultimatespro.com/images/" + _courseImge?.replace("courses/", "").replace(".jpg","_md.jpg")} 
                                                    hidden={(_courseImge) ? false : true} 
                                                    alt="" 
                                                    width={400} 
                                                    // style={{transform: "scaleX(-1)"}} 
                                                />
                                            </Col>
                                        )
                                    }
                                </FormGroup>
                                <FormGroup row={true}>
                                    <Label for="img" lg={3} sm={2}>Upload Course Flyer<br/><span style={{fontSize:"smaller"}}>(1280px x 800px)</span></Label >
                                    <Col lg={7} sm={4} style={{display: "flex"}}>
                                        <CustomInput id="3" type="file" name="img" accept="image/png, image/jpeg, image/jpg" 
                                            onChange={handleCourseFlyer} 
                                            innerRef={register} />
                                    </Col>
                                    <Button color="primary" disabled={_courseFlyerFlag} name="flyer" onClick={handleUploadAction}>Upload</Button>
                                    {
                                        _courseFlyerFlag === true && _courseFlyer && (
                                            <Col lg={12} sm={12} style={{paddingTop: "10px", textAlign: "center"}}>
                                                <img 
                                                    // ref={getProfilePicture}
                                                    src={"https://images.ultimatespro.com/images/" + _courseFlyer?.replace("courses/", "").replace(".jpg","_400x640.jpg")} 
                                                    hidden={(_courseFlyer) ? false : true} 
                                                    alt="" 
                                                    width={400} 
                                                    // style={{transform: "scaleX(-1)"}} 
                                                />
                                            </Col>
                                        )
                                    }
                                </FormGroup>
                                <FormGroup row={true}>
                                    <Label for="img" lg={3} sm={2}>Upload Course CPD Points<br/><span style={{fontSize:"smaller"}}>(800px x 1280px)</span></Label >
                                    <Col lg={7} sm={4} style={{display: "flex"}}>
                                        <CustomInput id="3" type="file" name="img" accept="image/png, image/jpeg, image/jpg" 
                                            onChange={handleCourseCPDPointInfo} 
                                            innerRef={register} />
                                    </Col>
                                    <Button color="primary" disabled={_courseCPDPointInfoFlag} name="cpdPointInfo" onClick={handleUploadAction}>Upload</Button>
                                    {
                                        _courseCPDPointInfoFlag === true && _courseCPDPointInfo && (
                                            <Col lg={12} sm={12} style={{paddingTop: "10px", textAlign: "center"}}>
                                                <img 
                                                    // ref={getProfilePicture}
                                                    src={"https://images.ultimatespro.com/images/" + _courseCPDPointInfo?.replace("courses/", "").replace(".jpg","_md.jpg")} 
                                                    hidden={(_courseCPDPointInfo) ? false : true} 
                                                    alt="" 
                                                    width={400} 
                                                />
                                            </Col>
                                        )
                                    }
                                </FormGroup>
                                <FormGroup row={true}>
                                    <Label for="courseVideo" lg={3} sm={2}>Course Video <br/><span style={{fontSize:"smaller"}}>Video format MP4, Aspect ratio 16:9, Minimum 1280x720</span></Label >
                                    <Col lg={7} sm={4} style={{display: "flex"}}>
                                        <CustomInput id="4" type="file" name="courseVideo" accept="video/mp4" 
                                            onChange={handleCourseVideo} 
                                            innerRef={register} />
                                    </Col>
                                    <Button color="primary" disabled={_courseVideoFlag} name="video" onClick={handleUploadAction}>Upload</Button>
                                    {
                                        _courseVideoFlag === true && _courseVideo && _courseImageFlag === true && _courseImge && (
                                            <Col lg={12} sm={12} className="mt-3">
                                                <VideoPlayer
                                                    sourceVideo={_sourceVideo}
                                                    videoThumbnail={"https://images.ultimatespro.com/images/" + _courseImge?.replace("courses/", "")}
                                                    hidden={(_sourceVideo.src) ? false : true}
                                                />
                                            </Col>
                                        )
                                    }
                                </FormGroup>
                            </ListGroupItem>
                        </ListGroupItem>
                    </ListGroup>
                )
            }
            {
                isNew && (
                    <p>**Course material can only be modify after save the new course.</p>
                )
            }
            <br />   

            <Input type="hidden" name="programOutline" value={JSON.stringify(_programOutline)} innerRef={register()} />
            <Input type="hidden" name="courseFeatures" value={JSON.stringify(_courseFeatures)} innerRef={register()} />
            <Input type="hidden" name="cpdPoints" value={JSON.stringify(cpdArray)} innerRef={register()} />
            <Input type="hidden" name="concentrationDurationSettingsJSON" value={JSON.stringify(_concentrateQuestion)} innerRef={register()} />
            <Input type="hidden" name="trainerFAQFileURL" value={_trainerFAQ} innerRef={register()} />
            <Input type="hidden" name="slidesFileURL" value={_courseSliders} innerRef={register()} />
            <Input type="hidden" name="videoURL" value={_courseVideo} innerRef={register()} />
            <Input type="hidden" name="videoThumbnailURL" value={_courseImge} innerRef={register()} />
            <Input type="hidden" name="courseFlyerURL" value={_courseFlyer} innerRef={register()} />
            <Input type="hidden" name="courseCPDPointInfoURL" value={_courseCPDPointInfo} innerRef={register()} />
            <Input type="hidden" name="courseStatus" value={_courseStatus} innerRef={register()} />
            <Input type="hidden" name="expiryDT" value={_expiryDT} innerRef={register()} />
            <Input type="hidden" name="duration" value={_courseDuration} innerRef={register()} />
            <Input type="hidden" name="organiser" value={JSON.stringify(_selectedOrganiser)} innerRef={register()} />
            <Input type="hidden" name="trainerProfile" value={JSON.stringify(_selectedTrainer)} innerRef={register()} />
            <Input type="hidden" name="Overwrite" value={overwriteFlag} innerRef={register()} />
            <Input type="hidden" name="publishStatus" value={publishFlag} innerRef={register()} />
            <Input type="hidden" name="_etag" defaultValue={props.data?._etag}  innerRef={register()} />

            <FormGroup row={true}>
                <Col sm={12}>
                    {
                        !isNew && (
                            <Button color="danger" size="lg" className="float-left" disabled={props.ui.loading || props.ui.processing} 
                                onClick={toggleRemoveWarning}>
                                <i className="fas fa-trash-alt mr-1"></i>&nbsp;Remove
                            </Button>
                        )
                    }
                    <Button type="submit" color="primary" size="lg" className="float-right" disabled={!dirty || props.ui.loading || props.ui.processing} 
                        onClick={() => setOverwriteFlag("false")}>
                        <i className="fas fa-save mr-1"></i>&nbsp;Save
                    </Button>
                    {
                        !isNew && (_courseStatus === "Active") && (
                            <Button type="submit" color="danger" size="lg" className="float-right mr-2" disabled={props.ui.loading || props.ui.processing} 
                                onClick={() => setPublishFlag("false")}>
                                <i className="fas fa-download mr-1"></i>&nbsp;UnPublished
                            </Button>
                        )
                    }
                    {
                        !isNew && (_courseStatus === "UnPublished") && (
                            <Button type="submit" color="success" size="lg" className="float-right mr-2" disabled={props.ui.loading || props.ui.processing} 
                                onClick={() => setPublishFlag("true")}>
                                <i className="fas fa-upload mr-1"></i>&nbsp;Publish
                            </Button>
                        )
                    }
                    {
                        props.ui.processing && (<Spinner color="warning" className="float-right">&nbsp;</Spinner>)
                    }   
                </Col>
            </FormGroup>
            <Modal isOpen={overwriteWarningFlag} toggle={overwriteHandleWarning}>
                <ModalHeader toggle={overwriteHandleWarning}>Warning</ModalHeader>
                <ModalBody>
                    <p>Record you changing is not the latest version. <br/>
                        Please confirm if you want to :- <br/>
                        1. Overwrite. Update latest data with your changes. <br/>
                        2. Reload. Discarding your current changes.<br/>
                        3. Cancel. Remain your changes.<br/>
                    </p>
                </ModalBody>
                <ModalFooter>                 
                    <Button form="DetailsFrom" type="submit" color="warning" size="lg" className="float-right" 
                        disabled={props.ui.loading || props.ui.processing} 
                        onClick={() => setOverwriteFlag("true")}>
                        <i className="fas fa-save mr-1"></i>&nbsp;Overwrite
                    </Button>
                    <Button color="danger" size="lg" onClick={handleReloadData}>
                        <i className="fas fa-redo-alt mr-1"></i>&nbsp; Reload
                    </Button>
                    <Button color="secondary" size="lg" onClick={overwriteHandleWarning}>
                        <i className="fas fa-times-circle mr-1"></i>&nbsp;Cancel
                    </Button>
                </ModalFooter>
            </Modal> 
            
            <Modal isOpen={removeWarning} toggle={toggleRemoveWarning} >
                <ModalHeader toggle={toggleRemoveWarning}>Warning</ModalHeader>
                <ModalBody>
                    <p>Please confirm to remove this record<br/>
                        Note. This action is irreversible.<br/>
                    </p>
                </ModalBody>
                <ModalFooter>    
                    <Button color="danger" size="lg" onClick={handleRequestDelete}>
                        <i className="fas fa-trash-alt mr-1"></i>&nbsp; Proceed to Remove
                    </Button>
                    <Button color="secondary" size="lg" onClick={toggleRemoveWarning}>
                        <i className="fas fa-times-circle mr-1"></i>&nbsp;Cancel
                    </Button>
                </ModalFooter>
            </Modal> 
            <Modal isOpen={props.ui.processState === 3} backdrop="static" keyboard={false} >
                <ModalHeader>Success</ModalHeader>
                <ModalBody>
                    <p>Succesfully remove!<br/>
                    </p>
                </ModalBody>
                <ModalFooter>    
                    <RouterNavLink to="/courses" className="nav-link" exact>
                        <i className="fas fa-list mr-1"></i>Back to Course List
                    </RouterNavLink>
                </ModalFooter>
            </Modal>

            <Modal size="lg" isOpen={CQFlag} toggle={toggleCQFlag} >
                <ModalHeader toggle={toggleCQFlag}>Concentrate Question</ModalHeader>
                <ModalBody>
                    <FormGroup row={true} >
                        <Label for="PopupPicTime" lg={3} sm={2}>Popup Picture Time</Label >
                        <Col lg={9} sm={10}>
                            <TimeField
                                value={_picTime.picTime1}
                                name="picTime1"
                                onChange={(e: any) => handleSetPicTime(e)}
                                showSeconds
                                style={{width: "70px"}}
                            />&nbsp;
                            <TimeField
                                value={_picTime.picTime2}
                                name="picTime2"
                                onChange={(e: any) => handleSetPicTime(e)}
                                showSeconds
                                style={{width: "70px"}}
                            />&nbsp;
                            <TimeField
                                value={_picTime.picTime3}
                                name="picTime3"
                                onChange={(e: any) => handleSetPicTime(e)}
                                showSeconds
                                style={{width: "70px"}}
                            />&nbsp;
                            <TimeField
                                value={_picTime.picTime4}
                                name="picTime4"
                                onChange={(e: any) => handleSetPicTime(e)}
                                showSeconds
                                style={{width: "70px"}}
                            />&nbsp;
                            <TimeField
                                value={_picTime.picTime5}
                                name="picTime5"
                                onChange={(e: any) => handleSetPicTime(e)}
                                showSeconds
                                style={{width: "70px"}}
                            />
                        </Col>
                    </FormGroup>
                    <FormGroup row={true} >
                        <Label for="_CQ" lg={3} sm={2}>Popup Answer Time</Label >
                        <Col lg={9} sm={10}>
                            <TimeField
                                value={_ansTime}
                                name="ansTime"
                                onChange={handleSetAnsTime}
                                showSeconds
                                style={{width: "70px"}}
                            />
                        </Col>
                    </FormGroup>
                </ModalBody>
                <ModalFooter>
                    <span style={{ color:"red"}}>Minimum 2 popup picture time</span>
                    <Button color="primary" onClick={addConcentrateQuestion} >Save</Button>
                </ModalFooter>
            </Modal>

            <Modal isOpen={UploadFlag} toggle={toggleUploadFlag}>
                <ModalHeader toggle={toggleUploadFlag}>{(_uploadProgress !== 100) ? "Upload in progressing" : "Upload Completed"}</ModalHeader>
                <ModalBody>
                    <Progress value={_uploadProgress}>{_uploadProgress}%</Progress>
                </ModalBody>
                <ModalFooter style={{justifyContent: "space-between"}}>
                    <p>Please click on "Save" button once upload completed</p>
                    <Button color="danger" disabled={(_uploadProgress !== 100) ? true : false} onClick={toggleUploadFlag}>Close</Button>
                </ModalFooter>
            </Modal> 

        </Form>
        <br/><br/>
        <br/>
        {/* <Row>
            <Col lg="12">
                {JSON.stringify(props.data)}
            </Col>
        </Row> */}
        <Prompt when={dirty && !isSubmitted} 
            message="Are you sure want to discard your changes?"
        />
    </div>
    
  );
}